<template>
  <div>
    <div class="row">
      <div class="col">
        <h4>Overview</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <p>
          This section allows our subscribers to share experiences and ideas to save money, to reduce resource usage,
          pollution and waste and to improve processes with other private clubs, hotels and resorts. This is the core of
          the Vivid Leaf system: a mind-share platform to learn what other clubs are doing to becoming more sustainable
          and being able to spend more on membership experiences rather than on utilities, waste, fertilizer and
          pesticides.
          <br />
          <br />
          Every new idea, process and initiative shared here will advance your clubs progress and score on your journey
          to sustainability and will also be recognized with innovation and leadership leafs, which can be published
          e.g. on LinkedIn.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4>Your Suggested Initiatives</h4>
      </div>
    </div>
    <div class="row">
      <div v-if="checkIfCanCreate()" class="col-2">
        <router-link :to="{ name: 'Create Suggestion' }">
          <p-button type="warning" outline> Create Suggestion </p-button>
        </router-link>
      </div>
      <div class="flex items-center justify-items-center">
        <div>
          <label for="show_review_pending" class="control-label">Review Pending?</label>
        </div>
        <div class="-mt-12 ml-4">
          <fg-input
            id="show_review_pending"
            type="radio"
            @checked="togggleSuggestionsList"
            :selected="filters.isReviewPending"
          >
          </fg-input>
        </div>
      </div>
    </div>
    <div class="row" v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else class="row">
      <div class="col">
        <QuestionsList
          :questions="questions"
          :question-type="questionType"
          :company="company"
          questionLayout="Suggestion"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionsList from '@/components/Questions/QuestionsList';
import QuestionHasTypeController from '@/controllers/QuestionHasType/QuestionHasTypeController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
import SuggestionController from '@/controllers/Question/SuggestionController';
import checkIfCanCreateSuggestion from '@/router/scopes/suggestions/CheckIfCanCreateSuggestion';
export default {
  name: 'Suggestions',
  components: { MoonLoader, QuestionsList },
  data() {
    return {
      questions: null,
      questionType: null,
      loading: false,
      loadingQuestions: false,
      questionTypes: true,
      company: true,
      filters: { isReviewPending: false },
    };
  },
  async beforeMount() {
    this.setLoading();
    await this.getCompany();
    await this.getQuestionTypes();
    await this.setQuestionType();
    await this.getSuggestions(this.questionType);
    this.resetLoading();
  },
  methods: {
    async getQuestionTypes() {
      this.questionTypes = await QuestionTypeController.index();
    },
    async getSuggestions(filters = {}) {
      this.questions = await SuggestionController.index(filters);

      return this.questions;
    },
    setLoading() {
      this.loading = true;
    },
    resetLoading() {
      this.loading = false;
    },
    async setQuestionType() {
      this.questionType = this.questionTypes.find((type) => {
        return type.name === 'Initiative';
      });
    },
    async getCompany() {
      this.company = this.$store.getters.company;
    },
    checkIfCanCreate() {
      return checkIfCanCreateSuggestion();
    },
    async togggleSuggestionsList(isChecked) {
      this.filters.isReviewPending = isChecked;
      await this.getSuggestions({ is_approved: this.filters.isReviewPending });
    },
  },
};
</script>

<style scoped></style>
